module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-row"
  }, [_c('v-combobox', {
    staticClass: "search-keyword",
    staticStyle: {
      "max-height": "40px",
      "margin-top": "12px"
    },
    attrs: {
      "width": "200",
      "height": "40px",
      "multiple": "",
      "outlined": "",
      "hide-details": "",
      "chips": "",
      "label": "Enter the keyword"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          key: JSON.stringify(data.item),
          staticClass: "v-chip--select-multi",
          attrs: {
            "input-value": data.selected,
            "disabled": data.disabled,
            "close": ""
          },
          on: {
            "click:close": function($event) {
              return _vm.removeKeyword(data.item)
            }
          }
        }, [_vm._v(_vm._s(data.item))])]
      }
    }]),
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "setting-btn",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "red lighten-2",
      "dark": ""
    }
  }, [_vm._v("settings")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-2"
  }, [_c('v-divider'), _vm._v(" "), _c('p', [_vm._v("Location")]), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "items": _vm.locations,
      "label": "Select influencer location"
    },
    model: {
      value: (_vm.location),
      callback: function($$v) {
        _vm.location = $$v
      },
      expression: "location"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "type": "text",
      "clearable": "",
      "label": "Negative Keyword"
    },
    model: {
      value: (_vm.negativeKeyword),
      callback: function($$v) {
        _vm.negativeKeyword = $$v
      },
      expression: "negativeKeyword"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', {
    staticClass: "body-2 font-weight-bold mt-3 pb-3"
  }, [_vm._v("Duration in Year")]), _vm._v(" "), _c('v-slider', {
    attrs: {
      "ticks": "always",
      "min": "1",
      "max": "10",
      "step": "1",
      "thumb-size": 24,
      "thumb-label": "always"
    },
    model: {
      value: (_vm.pastYear),
      callback: function($$v) {
        _vm.pastYear = $$v
      },
      expression: "pastYear"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("It will search posts from (" + _vm._s(_vm.pastDate) + ") ")])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0a100fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/influencer/InfluencerSearchBox.vue
// module id = 2267
// module chunks = 0